import { useEffect, useState } from 'react';
import type { DependencyList } from 'react';

interface AsyncState<T> {
  data: T | null;
  loading: boolean;
  error: Error | null;
}

function depsEqual(a: DependencyList, b: DependencyList) {
  return a.length === b.length && a.every((v, i) => Object.is(v, b[i]));
}

/** Fetch-on-mount helper — không kéo thêm dep (react-query...) cho MVP này. */
export function useAsync<T>(fn: () => Promise<T>, deps: DependencyList): AsyncState<T> {
  const [state, setState] = useState<AsyncState<T>>({ data: null, loading: true, error: null });
  const [prevDeps, setPrevDeps] = useState(deps);

  // Reset trong lúc render khi deps đổi — tránh setState đồng bộ ngay đầu effect.
  if (!depsEqual(prevDeps, deps)) {
    setPrevDeps(deps);
    setState({ data: null, loading: true, error: null });
  }

  useEffect(() => {
    let cancelled = false;
    fn()
      .then((data) => {
        if (!cancelled) setState({ data, loading: false, error: null });
      })
      .catch((error: Error) => {
        if (!cancelled) setState({ data: null, loading: false, error });
      });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return state;
}
